window.__fvCarousels = window.__fvCarousels || {};

window.initFeaturedVideoCarousel = function (sectionId) {
  const section = document.getElementById('fv-section-' + sectionId);
  if (!section) return;

  let track = document.getElementById('fvTrack-' + sectionId);
  const dotsWrap = document.getElementById('fvDots-' + sectionId);
  let prevBtn = section.querySelector('.fv-prev');
  let nextBtn = section.querySelector('.fv-next');

  if (!track || !dotsWrap) return;

  // ---- Clean slate every time this runs ----
  // The Shopify theme editor re-executes this section's inline script
  // whenever a setting changes. Cloning nodes drops any handlers/timers
  // left over from a previous run, so nothing ever stacks up or fires
  // twice.
  const existing = window.__fvCarousels[sectionId];
  if (existing) {
    if (existing.resizeHandler) window.removeEventListener('resize', existing.resizeHandler);
    if (existing.autoplayTimer) clearInterval(existing.autoplayTimer);
  }

  const freshTrack = track.cloneNode(true);
  track.parentNode.replaceChild(freshTrack, track);
  track = freshTrack;

  if (prevBtn) {
    const freshPrev = prevBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(freshPrev, prevBtn);
    prevBtn = freshPrev;
  }
  if (nextBtn) {
    const freshNext = nextBtn.cloneNode(true);
    nextBtn.parentNode.replaceChild(freshNext, nextBtn);
    nextBtn = freshNext;
  }

  dotsWrap.innerHTML = '';

  const cards = Array.from(track.children);
  const count = cards.length;
  if (!count) return;

  let active = Math.min(2, count - 1);

  // ---- Dots ----
  cards.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'fv-dot';
    dot.addEventListener('click', () => {
      active = i;
      render(true);
      restartAutoplay();
    });
    dotsWrap.appendChild(dot);
  });
  const dots = Array.from(dotsWrap.children);

  // ---- Card click navigates to that card ----
  cards.forEach((card, i) => {
    card.addEventListener('click', (e) => {
      if (e.target.closest('.fv-card-link')) return;
      active = i;
      render(true);
      restartAutoplay();
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      active = (active - 1 + count) % count;
      render(true);
      restartAutoplay();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      active = (active + 1) % count;
      render(true);
      restartAutoplay();
    });
  }

  function playActiveVideo() {
    cards.forEach((card, i) => {
      const video = card.querySelector('video.fv-media');
      if (!video) return;
      if (i === active) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  // Each card's position is derived straight from its circular distance
  // to `active` — there's no track-level transform or DOM reordering, so
  // wrapping past the last card back to the first is just normal modulo
  // arithmetic and always works, every time.
  function render() {
    const isMobile = window.innerWidth <= 640;
    const step = isMobile ? 130 : 190;

    cards.forEach((card, i) => {
      let diff = i - active;
      // shortest signed distance around the circle, e.g. for 5 cards
      // this keeps diff in roughly the range -2..2
      if (diff > count / 2) diff -= count;
      if (diff < -count / 2) diff += count;

      const abs = Math.abs(diff);
      let scale, translateY, opacity, zIndex, brightness, pointerEvents;

      if (diff === 0) {
        scale = 1.08; translateY = -14; opacity = 1; zIndex = 3; brightness = 1; pointerEvents = 'auto';
      } else if (abs === 1) {
        scale = 0.9; translateY = 0; opacity = 1; zIndex = 2; brightness = 0.85; pointerEvents = 'auto';
      } else {
        scale = 0.8; translateY = 10; opacity = 0; zIndex = 1; brightness = 0.72; pointerEvents = 'none';
      }

      card.style.transform = 'translateX(' + (diff * step) + 'px) translateY(' + translateY + 'px) scale(' + scale + ')';
      card.style.opacity = opacity;
      card.style.zIndex = zIndex;
      card.style.filter = 'brightness(' + brightness + ') saturate(' + (diff === 0 ? 1 : 0.9) + ')';
      card.style.pointerEvents = pointerEvents;
      card.style.boxShadow = diff === 0
        ? '0 22px 45px var(--fv-card-shadow)'
        : '0 10px 25px var(--fv-card-shadow)';
    });

    dots.forEach((d, i) => d.classList.toggle('active', i === active));

    playActiveVideo();
  }

  // ---- Autoplay: cycles forever, pausing only while the visitor's
  // mouse is over the carousel. ----
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let autoplayTimer = null;

  function startAutoplay() {
    if (prefersReducedMotion || count < 2) return;
    autoplayTimer = window.setInterval(() => {
      active = (active + 1) % count;
      render();
    }, 3500);
    window.__fvCarousels[sectionId] = window.__fvCarousels[sectionId] || {};
    window.__fvCarousels[sectionId].autoplayTimer = autoplayTimer;
  }
  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = null;
  }
  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);

  function onResize() { render(); }
  window.addEventListener('resize', onResize);

  window.__fvCarousels[sectionId] = {
    resizeHandler: onResize,
    autoplayTimer: autoplayTimer
  };

  render();
  startAutoplay();
};
